export default {
  account: 'アカウント',
  accountPlaceholder: 'アカウントを入力してください',
  operationTime: '操作日時',
  startTime: '開始日時',
  endTime: '終了日時',
  search: '検索',
  name: '名前',
  ip: 'IP',
  applicationModule: 'アプリケーションモジュール',
  operationContent: '操作内容',
  antiFake: '偽造防止トレーサビリティ',
  marketing: 'マーケティングキャンペーン',
};
